import React, { Component } from "react";
import CollapsibleSection from "../../../components/collapsibleSection/CollapsibleSection";
import ResearchPaperCarousel from "../../../components/researchPaperCarousel/ResearchPaperCarousel";
import "./../Projects.css";

const papers = [
  {
    file: "CoLocated_webXR_sigraphFailedPaper.pdf",
    title: "Co-Located WebXR (with Ken Perlin)",
    description:
      "Co-located multi-user WebXR experiences developed with Ken Perlin at NYU's Future Reality Lab. Submitted to SIGGRAPH but rejected. After I left the lab, a follow-up paper built on top of this work was accepted to SIGGRAPH without my name on it.",
    tags: ["WebXR", "Co-Located", "Multi-User", "Ken Perlin"],
    year: "2023",
    status: "Submitted to SIGGRAPH (Rejected)",
  },
  {
    file: "Haptic_helmet.pdf",
    title: "Haptic Helmet",
    description:
      "Haptic helmet system for engineering applications. Published in the 31st International Workshop on Intelligent Computing in Engineering.",
    tags: ["Haptics", "HCI", "Wearables"],
    year: "2024",
    status: "Published — 31st International EG-ICE",
  },
  {
    file: "GaussianSplatting_to_Mesh_Reconstruction.pdf",
    title: "Gaussian Splatting to Mesh Reconstruction",
    description:
      "Pipeline for converting 3D Gaussian Splatting representations into watertight triangle meshes. Explores extraction strategies, surface reconstruction trade-offs, and fidelity vs. compactness of the resulting geometry.",
    tags: ["3D Reconstruction", "Gaussian Splatting", "Geometry"],
    year: "2024",
    status: "Unpublished",
  },
  {
    file: "3D_Reconstruction_Of_Corridor.pdf",
    title: "3D Reconstruction of a Corridor",
    description:
      "Multi-view 3D reconstruction of an indoor corridor. Combines structure-from-motion and dense stereo to recover scene geometry from a hand-captured image sequence.",
    tags: ["Computer Vision", "SfM", "MVS"],
    year: "2024",
    status: "Unpublished",
  },
  {
    file: "Image_colorization_using_diffusion_in_LAB_color_space.pdf",
    title: "Image Colorization using Diffusion in LAB Color Space",
    description:
      "Diffusion-based colorization that operates in the perceptually uniform LAB space, conditioning on the L channel and predicting AB. Improves chromatic plausibility over RGB-space variants.",
    tags: ["Diffusion", "Colorization", "Generative"],
    year: "2024",
    status: "Unpublished",
  },
  {
    file: "VR_Path_Tracer.pdf",
    title: "VR Path Tracer",
    description:
      "Real-time path tracer targeting VR headsets. Discusses denoising, foveated sampling, and stereo coherence to keep frame budgets under control while preserving global illumination.",
    tags: ["Rendering", "Path Tracing", "VR"],
    year: "2024",
    status: "Unpublished",
  },
  {
    file: "Research_on_100Gbe_networks.pdf",
    title: "Research on 100GbE Networks",
    description:
      "Survey and experiments on 100 Gigabit Ethernet networks — bottlenecks, NIC offloads, and tuning strategies for sustained line-rate throughput in modern data centers.",
    tags: ["Networking", "Systems", "100GbE"],
    year: "2023",
    status: "Unpublished",
  },
];

class ResearchPapersProjects extends Component {
  constructor(props) {
    super(props);
    this.state = { isCollapsed: true };
  }

  render() {
    const theme = { ...this.props.theme };
    theme.header = "#FFFFFF";
    theme.text = "#4DB8FF";
    theme.highlight = "#4DB8FF";
    theme.secondaryText = "#A8D8FF";
    theme.cardBackground = "#0E1A2B";

    return (
      <div ref={this.props.reference}>
        <CollapsibleSection
          title="Research-Based Projects"
          theme={theme}
          isCollapsed={this.state.isCollapsed}
          onToggle={() =>
            this.setState({ isCollapsed: !this.state.isCollapsed })
          }
        >
          <div className="projects-main">
            <p
              style={{
                textAlign: "center",
                opacity: 0.75,
                marginBottom: "1.5rem",
                color: theme.text,
                fontSize: "1rem",
                maxWidth: "780px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              Research papers and hobby projects written up in paper form — some
              published, some shared here as a record of the work and ideas explored.
            </p>
            <ResearchPaperCarousel papers={papers} theme={theme} />
          </div>
        </CollapsibleSection>
      </div>
    );
  }
}

export default ResearchPapersProjects;
